import { render } from "./LogsVisorMenu.vue?vue&type=template&id=79944f62&scoped=true"
import script from "./LogsVisorMenu.vue?vue&type=script&lang=js"
export * from "./LogsVisorMenu.vue?vue&type=script&lang=js"

import "./LogsVisorMenu.vue?vue&type=style&index=0&id=79944f62&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79944f62"]])

export default __exports__